import type { NavigateFunction, Location } from 'react-router-dom'

/** Open the settings modal over the current screen (keeps background location). */
export function openSettings(navigate: NavigateFunction, location: Location) {
  const background =
    (location.state as { background?: Location } | null)?.background ?? location
  navigate('/settings', { state: { background } })
}
